import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { IconHome, IconUsers, IconPalnts, IconViewGrid, IconSubscriptions } from '@sfx/icons';
import { initAccountSettingApi, initHost } from '../api';
import { getSFxUser } from '../utils/checkSFxRoleAuth';
import UserManagement from './UserManagement/userManagement';
import SubscriptionsManagement from './SubscriptionManagement';
import PlantManagement from './PlantManagement';
import SolutionManagement from './SolutionManagement';
import { getTransFunc } from '../../Basic/SFxLocalization';

import { RequestCacheProvider } from './common/hooks/fetchCacheContext';
export var prefix = 'sfx-react-ui-account-setting';
var menuList = [{
  id: 1,
  SFxPrivilegeName: 'users',
  name: 'SFxAccountSettingsMenuUsers',
  icon: /*#__PURE__*/React.createElement(IconUsers, {
    size: "16"
  }),
  component: UserManagement
}, {
  id: 2,
  SFxPrivilegeName: 'solutions',
  name: 'SFxAccountSettingsMenuSolutions',
  icon: /*#__PURE__*/React.createElement(IconViewGrid, {
    size: "20",
    style: {
      marginLeft: '-3px'
    }
  }),
  component: SolutionManagement
}, {
  id: 3,
  SFxPrivilegeName: 'subscriptions',
  name: 'SFxAccountSettingsMenuSubscriptions',
  icon: /*#__PURE__*/React.createElement(IconSubscriptions, {
    size: "16"
  }),
  component: SubscriptionsManagement
}, {
  id: 4,
  SFxPrivilegeName: 'plants',
  name: 'SFxAccountSettingsMenuPlants',
  icon: /*#__PURE__*/React.createElement(IconPalnts, {
    size: "16"
  }),
  component: PlantManagement
}];

var AccountSettings = /*#__PURE__*/function (_Component) {
  _inherits(AccountSettings, _Component);

  var _super = _createSuper(AccountSettings);

  function AccountSettings() {
    var _this;

    _classCallCheck(this, AccountSettings);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      activeMenu: {},
      menuList: [],
      hasUsersPrivilege: false,
      authUser: {},
      translate: getTransFunc()
    });

    _defineProperty(_assertThisInitialized(_this), "getMenuList", function (authUser) {
      var _authUser$SFxPrivileg = authUser.SFxPrivilege,
          SFxPrivilege = _authUser$SFxPrivileg === void 0 ? [] : _authUser$SFxPrivileg,
          _authUser$hasUsersPri = authUser.hasUsersPrivilege,
          hasUsersPrivilege = _authUser$hasUsersPri === void 0 ? false : _authUser$hasUsersPri;
      var _this$props$options$a = _this.props.options.activeMenu,
          activeMenu = _this$props$options$a === void 0 ? '' : _this$props$options$a;
      var SFxPrivilegeMenuList = [];

      if (SFxPrivilege) {
        SFxPrivilegeMenuList = SFxPrivilege.map(function (s) {
          return _objectSpread(_objectSpread({}, menuList.find(function (m) {
            return m.SFxPrivilegeName === s;
          })), {}, {
            s: s
          });
        });
      }

      if (!hasUsersPrivilege) {
        SFxPrivilegeMenuList = [menuList[0]].concat(SFxPrivilegeMenuList);
      }

      _this.setState({
        menuList: SFxPrivilegeMenuList,
        activeMenu: activeMenu ? SFxPrivilegeMenuList.find(function (i) {
          return i.SFxPrivilegeName === activeMenu;
        }) : SFxPrivilegeMenuList[0]
      });
    });

    _defineProperty(_assertThisInitialized(_this), "breadcrumbClick", function () {
      if (_this.props.options && _this.props.options.breadcrumbClick) {
        _this.props.options.breadcrumbClick();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "menuClick", function (i) {
      _this.setState({
        activeMenu: i
      });

      if (_this.props.options && _this.props.options.routerChange) {
        _this.props.options.routerChange(i);
      }
    });

    return _this;
  }

  _createClass(AccountSettings, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      initHost(this.props.options);
      initAccountSettingApi(this.props.options);
      var authUser = getSFxUser(this.props.options) || {};
      var hasUsersPrivilege = authUser.hasUsersPrivilege;
      this.setState({
        hasUsersPrivilege: hasUsersPrivilege,
        authUser: authUser
      });
      this.getMenuList(authUser);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          menuList = _this$state.menuList,
          _this$state$activeMen = _this$state.activeMenu,
          activeMenu = _this$state$activeMen === void 0 ? {
        name: ''
      } : _this$state$activeMen,
          authUser = _this$state.authUser,
          translate = _this$state.translate,
          hasUsersPrivilege = _this$state.hasUsersPrivilege;
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix)
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-left")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-left-Breadcrumb")
      }, /*#__PURE__*/React.createElement("span", {
        className: "nav-home",
        onClick: this.breadcrumbClick
      }, /*#__PURE__*/React.createElement(IconHome, {
        size: "18",
        style: {
          marginBottom: '2px'
        }
      }), /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefix, "-left-Breadcrumb-text")
      }, translate('SFxAccountSettingsBreadcrumbHome'))), /*#__PURE__*/React.createElement("i", {
        className: "".concat(prefix, "-left-Breadcrumb-text")
      }, "/\xA0"), /*#__PURE__*/React.createElement("span", null, translate('SFxAccountSettingsTitle'))), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-left-title")
      }, translate('SFxAccountSettingsTitle')), /*#__PURE__*/React.createElement("ul", {
        className: "".concat(prefix, "-left-menu")
      }, menuList.map(function (i) {
        return /*#__PURE__*/React.createElement("li", {
          onClick: function onClick() {
            return _this2.menuClick(i);
          },
          key: i.id,
          className: activeMenu.name === i.name ? 'active' : ''
        }, i.icon, /*#__PURE__*/React.createElement("span", null, translate(i.name)));
      }))), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-content")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-content-title")
      }, translate(activeMenu.name)), /*#__PURE__*/React.createElement(RequestCacheProvider, null, activeMenu.component && /*#__PURE__*/React.createElement(activeMenu.component, {
        prefix: prefix,
        hasUsersPrivilege: hasUsersPrivilege,
        authUser: authUser,
        translate: translate
      }))));
    }
  }]);

  return AccountSettings;
}(Component);

export default AccountSettings;